export const PHONE_NUMBER = "1300 800 966";
export const BRAND_NAME = "Telstra Business Website Services";
